import { z } from 'zod';

const ESCALATION_TARGETS = ['duty_manager', 'medical_director', 'executive_director'] as const;
const ACTION_TYPES = [
  'update', 'assign', 'direct', 'rca', 'request_rca', 'escalate', 'close', 'reopen',
] as const;

export const createIncidentSchema = z.object({
  location:    z.string().min(2, 'الموقع مطلوب'),
  // category_id is optional — user may not select a category
  category_id: z.string().uuid('يرجى اختيار تصنيف الحدث').optional().or(z.literal('')),
  event_type:  z.string().min(2, 'نوع الحدث مطلوب'),
  likelihood:  z.number().int().min(1).max(5),
  impact:      z.number().int().min(1).max(5),
  // risk_level is derived server-side from likelihood × impact, not submitted by client
  description: z.string().min(10, 'الوصف يجب أن يكون 10 أحرف على الأقل'),
  is_repeated: z.boolean().default(false),
  reference:   z.string().optional(),
  dept_id:     z.string().uuid().optional(),
});

export const incidentActionSchema = z.object({
  incident_id:  z.string().uuid(),
  action_type:  z.enum(ACTION_TYPES),
  action_name:  z.string().optional(),
  description:  z.string().optional(),
  target:       z.string().optional(),
  escalate_to:  z.enum(ESCALATION_TARGETS).optional(),
}).superRefine((data, ctx) => {
  if (data.action_type === 'close' && !data.description) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'سبب الإغلاق إجباري', path: ['description'] });
  }
  if (data.action_type === 'direct' && !data.target) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'القسم المعني مطلوب', path: ['target'] });
  }
  if (data.action_type === 'assign' && !data.target) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'الموظف المسند إليه مطلوب', path: ['target'] });
  }
  if (data.action_type === 'escalate' && !data.escalate_to) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'جهة التصعيد مطلوبة', path: ['escalate_to'] });
  }
});

export type CreateIncidentInput = z.infer<typeof createIncidentSchema>;
export type IncidentActionInput = z.infer<typeof incidentActionSchema>;
